import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './Landing.css';

const LANDING_DURATION_MS = 6000;
const QUOTE = 'Whether you think you can or think you can\'t, you\'re right.';

const LandingComponent = () => {
    const navigate = useNavigate();
    const [displayedText, setDisplayedText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/home', { replace: true });
        }, LANDING_DURATION_MS);

        return () => clearTimeout(timer);
    }, [navigate]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (currentIndex < QUOTE.length) {
                setDisplayedText(prevText => prevText + QUOTE[currentIndex]);
                setCurrentIndex(prevIndex => prevIndex + 1);
            } else {
                clearInterval(interval);
            }
        }, 40);

        return () => clearInterval(interval);
    }, [currentIndex]);

    return (
        <main id="landing-page" style={{ '--landing-duration': `${LANDING_DURATION_MS}ms` }}>
            <div id="landing-ambient-grid" />
            <section id="landing-hero" aria-label="Nathan R. Heinz portfolio intro">
                <div id="landing-brand-lockup">
                    <span id="landing-brand-mark">NRH</span>
                    <span id="landing-brand-kicker">Software Engineer</span>
                </div>

                <div id="landing-copy">
                    <span>Portfolio Online</span>
                    <h1>Nathan R. Heinz</h1>
                    <p>Building sharp, interactive web experiences with a little voltage in the edges.</p>
                </div>

                <div id="landing-quote" aria-live="polite">
                    <p>{displayedText}</p>
                </div>

                <div id="landing-status" aria-live="polite">
                    <span>Entering portfolio</span>
                    <div id="landing-progress" aria-hidden="true">
                        <span />
                    </div>
                </div>
            </section>
        </main>
    );
};

export default LandingComponent;
